import { render, staticRenderFns } from "./MessageTemplates.vue?vue&type=template&id=dca07ec8&scoped=true"
import script from "./MessageTemplates.vue?vue&type=script&lang=js"
export * from "./MessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca07ec8",
  null
  
)

export default component.exports